var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('TopNavBar'),_c('router-view',{staticStyle:{"margin-top":"64px"}}),_c('CustomFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }